import React, { useState } from "react"
import LazyImage from "../../components/LazyImage"
import AppLink from "../../components/AppLink"
import ArrowRight from "../../components/icons/ArrowRight"
import ClutchLogo from "../../assets/images/clutch.svg"
import "./index.scss"
import PlusIcon from "../../components/icons/PlusIcon"
import MinusIcon from "../../components/icons/MinusIcon"

export const OneClient = ({
    image,
    imageAlt,
    name,
    desc,
    country,
    clutch,
    link,
    text,
    linkedin,
    more = false,
}) => {
    const [showMore, setShowMore] = useState(false)

    return (
        <>
            <div className="one-client">
                <LazyImage
                    alt={imageAlt || "client photo"}
                    src={image}
                    className="one-client-image"
                />
                <div className="one-client-info">
                    <h4 className="t-s1">{name}</h4>
                    <hr />
                    <h5 className="t-b3">{desc}</h5>
                    <h6 className="t-b3">
                        {country || (
                            <AppLink className="t-link" href={linkedin}>
                                Linkedin
                            </AppLink>
                        )}
                    </h6>
                </div>
                {!more ? (
                    <p className="one-client-info-description t-b4">{text}</p>
                ) : (
                    <div className="case-developer-text">
                        <div data-showfull={showMore}>
                            <p className="case-developer-text-info t-b4">{text}</p>
                        </div>
                        {showMore && <hr/>}
                        <h6
                            className="case-developer-text-more t-nav"
                            onClick={() => setShowMore(!showMore)}
                        >
                            {!showMore ? "READ MORE" : "COLLAPSE"}{" "}
                            {!showMore ? <PlusIcon /> : <MinusIcon />}
                        </h6>
                    </div>
                )}
                <div className="one-client-links">
                    {link && (
                        <AppLink className="one-client-link hov-get-in-touch-black" href={link}>
                            LEARN MORE <ArrowRight width={26} color={"#FFF"} />
                        </AppLink>
                    )}
                    {clutch && (
                        <AppLink href={clutch}>
                            <img src={ClutchLogo} width={71} height={20} alt="Clutch logo"/>
                        </AppLink>
                    )}
                </div>
            </div>
            <div className="one-client-desktop">
                <LazyImage
                    alt={imageAlt || "client photo"}
                    src={image}
                    className="one-client-desktop-image"
                />
                <div className="one-client-desktop-info">
                    <div>
                        <h4 className="t-s1">{name}</h4>
                        <hr />
                        <h5 className="t-b3">{desc}</h5>
                        <h6 className="t-b3">
                            {country || (
                                <AppLink className="one-client-desktop-info-linkedin t-link hov-get-in-touch-black" href={linkedin}>
                                    Linkedin
                                </AppLink>
                            )}
                        </h6>
                    </div>
                    {clutch && (
                        <AppLink href={clutch}>
                            <img src={ClutchLogo} width={89} height={25} alt="Clutch logo"/>
                        </AppLink>
                    )}
                </div>
                <div className="one-client-desktop-text">
                    <span className="t-b4">
                        <hr />
                        {text.map((el, id) => (
                            <div key={id}>
                                <p className="t-b3">
                                    {el}
                                </p>
                                <br />
                            </div>
                        ))}
                    </span>
                    {link && (
                        <div className="one-client-desktop-links">
                            <AppLink
                                className="one-client-desktop-link hov-get-in-touch-black"
                                href={link}
                            >
                                LEARN MORE{" "}
                                <ArrowRight width={26} color={"#FFF"} />
                            </AppLink>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
